import React from "react";
import {
  Box,
  Container,
  VStack,
  Heading,
  Text,
  Icon,
  Button,
  Link,
} from "@chakra-ui/react";
import { MdBlock, MdEmail } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { ChatState } from "../Context/ChatProvider";
import { SUPPORT_EMAIL } from "../config/constants";

const CustomerBanned = () => {
  const navigate = useNavigate();
  const { setUser } = ChatState();

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userInfo");
    setUser(null);
    navigate("/login");
  };

  return (
    <Container maxW="xl" centerContent>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        width="100%"
      >
        <VStack
          spacing={6}
          bg="white"
          p={8}
          borderRadius="lg"
          borderWidth="1px"
          boxShadow="lg"
          textAlign="center"
        >
          <Icon as={MdBlock} w={20} h={20} color="red.500" />

          <Heading size="xl" color="gray.700">
            Account Banned
          </Heading>

          <Text fontSize="lg" color="gray.600" maxW="md">
            Your account has been banned and you no longer have access to this
            platform.
          </Text>

          <Box
            bg="red.50"
            p={4}
            borderRadius="md"
            borderWidth="1px"
            borderColor="red.200"
            width="100%"
          >
            <VStack spacing={3}>
              <Icon as={MdEmail} w={8} h={8} color="red.500" />
              <Text fontSize="md" fontWeight="semibold" color="gray.700">
                Need assistance?
              </Text>
              <Text fontSize="sm" color="gray.600">
                If you believe this is a mistake, please contact support:
              </Text>
              <Link
                href={`mailto:${SUPPORT_EMAIL}`}
                fontSize="lg"
                color="blue.500"
                fontWeight="bold"
                _hover={{ textDecoration: "underline" }}
              >
                {SUPPORT_EMAIL}
              </Link>
            </VStack>
          </Box>

          <Button
            colorScheme="red"
            variant="solid"
            onClick={handleLogout}
            mt={4}
          >
            Logout
          </Button>
        </VStack>
      </Box>
    </Container>
  );
};

export default CustomerBanned;
